import { Injectable } from "@angular/core";
import {
	Router,
	RouterStateSnapshot,
	ActivatedRouteSnapshot
} from "@angular/router";
import { MvMsalService } from "@aot/host-app-widgets-demo";
import { MsalGuard } from "@azure/msal-angular";

@Injectable({
	providedIn: "root"
})
export class MvRouteGuardService {
	constructor(private readonly router: Router, private readonly mvMsalService: MvMsalService, private msalGuard: MsalGuard) {}

	public canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean {
		if (this.msalGuard.canActivate(route, state)) {
            if (this.mvMsalService.isAuthorized()) {
                return true;
            } else {
                this.router.navigateByUrl("/");
                return false;
            }
        } else {
            return false;
		}
	}

	public canActivateChild(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean {
		return this.canActivate(route, state);
	}
}
